import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './privacy.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './privacy.component.scss'
})
export class PrivacyComponent {}
